(function () {
  'use strict';

  var STORAGE_KEY = 'ns-fav-handles';
  var lastFavProducts = [];

  // Show/hide the "Send us this list" footer button + hint with the list state
  function toggleFavFooter(show, products) {
    if (products) { lastFavProducts = products; }
    if (!show) { lastFavProducts = []; }
    var b = document.getElementById('ns-fav-send');
    var h = document.getElementById('ns-fav-hint');
    if (b) b.hidden = !show;
    if (h) h.hidden = !show;
  }

  // Build a mailto: pre-filled with the saved items so the customer can send
  // their wishlist straight to North Shore for a quote.
  function buildQuoteMailto() {
    var btn = document.getElementById('ns-fav-send');
    var email = (btn && btn.getAttribute('data-fav-email')) || 'northshoreballoondecor@gmail.com';
    var handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    var titleByHandle = {};
    lastFavProducts.forEach(function (p) { titleByHandle[p.handle] = p.title; });
    var lines = handles.map(function (h) {
      return '- ' + (titleByHandle[h] || h) + '  (' + location.origin + '/products/' + h + ')';
    });
    var subject = 'Balloon wishlist / quote request';
    var body = 'Hi North Shore,\n\nI would love a quote on these saved items:\n\n' + lines.join('\n') +
      '\n\nA bit about my event:\nDate:\nLocation:\nGuest count / theme:\n\nThank you!';
    return 'mailto:' + email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function save(handles) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(handles)); }
    catch (e) {}
  }

  function dispatch(handle, active) {
    document.dispatchEvent(new CustomEvent('ns:fav:change', {
      bubbles: true,
      detail: { handle: String(handle), active: active, count: load().length }
    }));
  }

  var NSFavorites = {

    toggle: function (handle) {
      handle = String(handle);
      var handles = load();
      var idx = handles.indexOf(handle);
      var active;
      if (idx === -1) {
        handles.push(handle);
        active = true;
      } else {
        handles.splice(idx, 1);
        active = false;
      }
      save(handles);
      dispatch(handle, active);
      return active;
    },

    has: function (handle) {
      return load().indexOf(String(handle)) !== -1;
    },

    count: function () {
      return load().length;
    },

    getAll: function () {
      return load().slice();
    },

    openList: function () {
      var drawer = document.getElementById('ns-fav-drawer');
      var overlay = document.getElementById('ns-fav-overlay');
      if (!drawer || !overlay) return;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      NSFavorites.renderDrawer();
    },

    closeList: function () {
      var drawer = document.getElementById('ns-fav-drawer');
      var overlay = document.getElementById('ns-fav-overlay');
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    renderDrawer: function () {
      var body = document.getElementById('ns-fav-body');
      var countEl = document.getElementById('ns-fav-drawer-count');
      if (!body) return;

      var handles = NSFavorites.getAll();
      if (countEl) countEl.textContent = handles.length + (handles.length === 1 ? ' item' : ' items');

      if (handles.length === 0) {
        body.innerHTML =
          '<div class="ns-fav-empty">' +
          '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l9.84-9.84a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '<h3 class="ns-fav-empty__title">Nothing saved yet</h3>' +
          '<p class="ns-fav-empty__text">Tap the heart on any product to save it here for later.</p>' +
          '</div>';
        toggleFavFooter(false);
        return;
      }

      body.innerHTML = '<div class="ns-fav-loading" aria-live="polite"><span>Loading your items…</span></div>';

      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(Boolean);
        if (valid.length === 0) {
          body.innerHTML = '<div class="ns-fav-empty"><p class="ns-fav-empty__text">Some saved items are no longer available.</p></div>';
          toggleFavFooter(false);
          return;
        }

        var html = '<ul class="ns-fav-list">';
        valid.forEach(function (p) {
          var imgSrc = p.featured_image || '';
          var priceStr = '$' + Math.floor(p.price_min / 100);
          if (p.price_min !== p.price_max) priceStr = 'From $' + Math.floor(p.price_min / 100);

          html += '<li class="ns-fav-item">';
          if (imgSrc) {
            html += '<a href="/products/' + p.handle + '" class="ns-fav-item__img-wrap">';
            html += '<img class="ns-fav-item__img" src="' + imgSrc + '&width=160&height=160&crop=center" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" width="80" height="80" loading="lazy">';
            html += '</a>';
          }
          html += '<div class="ns-fav-item__body">';
          html += '<a href="/products/' + p.handle + '" class="ns-fav-item__title">' + p.title + '</a>';
          html += '<p class="ns-fav-item__price">' + priceStr + '</p>';
          html += '<div class="ns-fav-item__actions">';
          html += '<a href="/products/' + p.handle + '" class="ns-fav-item__view">View Product</a>';
          html += '<button class="ns-fav-item__remove" data-ns-remove-fav="' + p.handle + '" type="button" aria-label="Remove ' + (p.title || '').replace(/"/g, '&quot;') + ' from saved items">Remove</button>';
          html += '</div></div></li>';
        });
        html += '</ul>';
        body.innerHTML = html;
        toggleFavFooter(true, valid);

        body.querySelectorAll('[data-ns-remove-fav]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var handle = btn.getAttribute('data-ns-remove-fav');
            NSFavorites.toggle(handle);
            var item = btn.closest('.ns-fav-item');
            if (item) item.remove();
            if (countEl) {
              var n = NSFavorites.count();
              countEl.textContent = n + (n === 1 ? ' item' : ' items');
            }
            if (!body.querySelector('.ns-fav-item')) NSFavorites.renderDrawer();
          });
        });
      });
    }
  };

  window.NSFavorites = NSFavorites;

  document.addEventListener('DOMContentLoaded', function () {
    // Sync nav badge on load
    var count = NSFavorites.count();
    var badge = document.getElementById('ns-fav-count');
    if (badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', count);
      badge.style.display = count > 0 ? 'flex' : 'none';
    }

    // Wire product card heart buttons
    function initFavBtns() {
      document.querySelectorAll('[data-ns-favorites-btn]').forEach(function (btn) {
        var handle = btn.getAttribute('data-ns-favorite-handle');
        if (!handle) return;
        if (NSFavorites.has(handle)) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        }
        if (!btn.hasAttribute('data-ns-fav-bound')) {
          btn.setAttribute('data-ns-fav-bound', '1');
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var active = NSFavorites.toggle(handle);
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-pressed', String(active));
          });
        }
      });
    }
    initFavBtns();

    // Overlay + close button
    var overlay = document.getElementById('ns-fav-overlay');
    if (overlay) overlay.addEventListener('click', function () { NSFavorites.closeList(); });
    var closeBtn = document.getElementById('ns-fav-close');
    if (closeBtn) closeBtn.addEventListener('click', function () { NSFavorites.closeList(); });

    // "Send us this list for a quote" → opens a pre-filled email to North Shore
    var sendBtn = document.getElementById('ns-fav-send');
    if (sendBtn) sendBtn.addEventListener('click', function () {
      if (NSFavorites.count() === 0) return;
      window.location.href = buildQuoteMailto();
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') NSFavorites.closeList();
    });
  });

  // Re-sync all card buttons whenever favorites change
  document.addEventListener('ns:fav:change', function () {
    var badge = document.getElementById('ns-fav-count');
    if (badge) {
      var n = NSFavorites.count();
      badge.textContent = n;
      badge.setAttribute('data-count', n);
      badge.style.display = n > 0 ? 'flex' : 'none';
    }
    document.querySelectorAll('[data-ns-favorites-btn]').forEach(function (btn) {
      var handle = btn.getAttribute('data-ns-favorite-handle');
      if (!handle) return;
      var active = NSFavorites.has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  });

})();
